/**
 * Fetch an SVG file as text and extract its original fill colors.
 * The returned svgText can be passed to Fabric's loadSVGFromString.
 */
export const fetchSvgTextAndColors = async (
  url: string
): Promise<{ svgText: string; originalColors: string[] }> => {
  const response = await fetch(url, { credentials: 'include' });
  const svgText = await response.text();

  const parser = new DOMParser();
  const doc = parser.parseFromString(svgText, 'image/svg+xml');
  const fills = new Set<string>();

  doc.querySelectorAll('[fill]').forEach((el) => {
    const fill = el.getAttribute('fill');
    if (fill && fill !== 'none' && fill !== 'transparent') {
      fills.add(fill.toLowerCase());
    }
  });

  // Also check inline style fill declarations
  doc.querySelectorAll('[style]').forEach((el) => {
    const style = el.getAttribute('style') ?? '';
    const match = style.match(/fill\s*:\s*([^;]+)/i);
    if (match) {
      const fill = match[1].trim().toLowerCase();
      if (fill !== 'none' && fill !== 'transparent') {
        fills.add(fill);
      }
    }
  });

  return { svgText, originalColors: Array.from(fills) };
};
